// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"65870834","796":"715cad91"}[chunkId] + ".chunk.js";
};